import { BookOpen, Mail, Github } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white">AusLearn</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              专为澳大利亚Year 7-10学生打造的智能学习平台，涵盖数学、英语等核心科目，
              助力学生备战NAPLAN和VCE考试。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">快速链接</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/subjects" className="hover:text-blue-400 transition-colors">
                  题库中心
                </Link>
              </li>
              <li>
                <Link to="/exams" className="hover:text-blue-400 transition-colors">
                  模拟考试
                </Link>
              </li>
              <li>
                <Link to="/flashcards" className="hover:text-blue-400 transition-colors">
                  记忆卡片
                </Link>
              </li>
              <li>
                <Link to="/leaderboard" className="hover:text-blue-400 transition-colors">
                  排行榜
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:support@auslearn.edu" className="hover:text-blue-400 transition-colors">
                  support@auslearn.edu
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Github className="w-4 h-4" />
                <a href="#" className="hover:text-blue-400 transition-colors">
                  开源社区
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © 2026 AusLearn. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-slate-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-slate-300 transition-colors">服务条款</a>
            <a href="#" className="hover:text-slate-300 transition-colors">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
